import * as actionTypes from '../actions/actionTypes';

import { updateObject } from '../../shared/utilities';

const initalState = {
    data: [],
    loading: false,
    deleting: false,
    posted: false,
    error: null,
    fileDeleted: false,
    deletingFile: false,
    uploaded: false,
    errorDeletingFile: null,
    progress: 0.0
};

const reducer = (state = initalState, action) => {
    switch (action.type) {
        // Add
        case actionTypes.EXPERIENCE_ADD_INIT:
            return updateObject(state, { loading: false, posted: false, error: null });

        case actionTypes.EXPERIENCE_ADD_START:
            return updateObject(state, { loading: true });

        case actionTypes.EXPERIENCE_ADD_SUCCESS:
            const newExperience = updateObject(action.data, { id: action.id });
            return updateObject(state, {
                loading: false,
                posted: true,
                error: null,
                data: state.data.concat(newExperience)
            });

        case actionTypes.EXPERIENCE_ADD_FAIL:
            return updateObject(state, { loading: false, posted: false, error: action.error });

        // Update
        case actionTypes.EXPERIENCE_UPDATE_SUCCESS:
            return updateObject(state, {
                loading: false,
                posted: true,
                error: null,
            });


        // Fetch
        case actionTypes.EXPERIENCE_FETCH_START:
            return updateObject(state, { loading: true });

        case actionTypes.EXPERIENCE_FETCH_SUCCESS:
            return updateObject(state, {
                loading: false,
                data: action.data
            });

        case actionTypes.EXPERIENCE_FETCH_FAIL:
            return updateObject(state, { loading: false, error: action.error });


        // Find by ID
        case actionTypes.EXPERIENCE_FINDBYID_START:
            return updateObject(state, { loading: true });

        case actionTypes.EXPERIENCE_FINDBYID_SUCCESS:
            return updateObject(state, {
                loading: false,
                data: action.data
            });
        case actionTypes.EXPERIENCE_FINDBYID_FAIL:
            return updateObject(state, { loading: false, error: action.error });


        // Delete
        case actionTypes.EXPERIENCE_DELETE_START:
            return updateObject(state, { deleting: true, });

        case actionTypes.EXPERIENCE_DELETE_SUCCESS:
            return updateObject(state, { deleting: false });

        case actionTypes.EXPERIENCE_DELETE_FAIL:
            return updateObject(state, { deleting: false, error: action.error });


        // Upload
        case actionTypes.EXPERIENCE_UPLOADFILE_START:
            return updateObject(state, { uploaded: false });

        case actionTypes.EXPERIENCE_UPLOADFILE_PROGRESS:
            return updateObject(state, { progress: action.progress });

        case actionTypes.EXPERIENCE_UPLOADFILE_SUCCESS:
            return updateObject(state, { uploaded: true, progress: 0.0 });

        case actionTypes.EXPERIENCE_UPLOADFILE_FAIL:
            return updateObject(state, { uploaded: false, error: action.error });

        case actionTypes.EXPERIENCE_DELETE_FILE_START:
            return updateObject(state, { deletingFile: true });

        case actionTypes.EXPERIENCE_DELETE_FILE_SUCCESS:
            return updateObject(state, { fileDeleted: true, deletingFile: false });

        case actionTypes.EXPERIENCE_DELETE_FILE_FAIL:
            return updateObject(state, { deletingFile: false, errorDeletingFile: action.errorDeletingFile });

        default:
            return state;
    }
};

export default reducer;